import { get, post, put, del } from "aws-amplify/api";
import { MobileAuth } from "./auth";
import type {
  HotelRate,
  OtaDemand,
  CompetitorHotel,
  OtaHotelCompetitorsResponse,
  PublishRates,
  RemoveSuggestedRate,
  AcceptSuggestedRate,
  SuggestedRate,
} from "./defs";

export class MobileApi {
  static async getHotels() {
    const rep = await get({
      apiName: "yield",
      path: `/hotels`,
      options: {
        headers: {
          Authorization: await MobileAuth.getAuthToken(),
        },
      },
    }).response;
    const text = await rep.body.text();
    const payload = JSON.parse(text);
    return payload;
  }

  static async publishrates(body: PublishRates) {
    return post({
      apiName: "yield",
      path: `/rates/${body.hotelId}/publish`,
      options: {
        body: { ...body },
        headers: {
          Authorization: await MobileAuth.getAuthToken(),
        },
      },
    });
  }

  static async removeSuggRate(body: RemoveSuggestedRate) {
    return del({
      apiName: "yield",
      path: `/rates/${body.hotelId}/suggested/${body.start}/${body.end}`,
      options: {
        headers: {
          Authorization: await MobileAuth.getAuthToken(),
        },
      },
    });
  }

  static async acceptSuggestedRate(body: AcceptSuggestedRate) {
    return post({
      apiName: "yield",
      path: `/rates/${body.hotelId}/suggested/${body.start}/${body.end}`,
      options: {
        body: { ...body },
        headers: {
          Authorization: await MobileAuth.getAuthToken(),
        },
      },
    });
  }

  static async suggestRate(body: SuggestedRate) {
    return put({
      apiName: "yield",
      path: `/rates/${body.hotelId}/suggested/${body.start}/${body.end}`,
      options: {
        body: { ...body },
        headers: {
          Authorization: await MobileAuth.getAuthToken(),
        },
      },
    });
  }

  static async getSuggDays(
    currentHotelId: number,
    currentDate: string,
    twoYear: string,
  ) {
    const rep = await get({
      apiName: "yield",
      path: `/days/suggested/${currentHotelId}/${currentDate}/${twoYear}`,
      options: {
        headers: {
          Authorization: await MobileAuth.getAuthToken(),
        },
      },
    }).response;
    const text = await rep.body.text();
    const payload = JSON.parse(text);
    return payload;
  }

  static async getHotelConfig(hotelId: number) {
    const rep = await get({
      apiName: "config",
      path: `/hotels/${hotelId}`,
      options: {
        headers: {
          Authorization: await MobileAuth.getAuthToken(),
        },
      },
    }).response;
    const text = await rep.body.text();
    const payload = JSON.parse(text);
    return payload;
  }

  static async getDemandFromOTATable(
    otaHotelId: number,
    startDate: string,
    endDate: string,
  ): Promise<Record<string, OtaDemand>> {
    const rep = await get({
      apiName: "yield",
      path: `/ota/${otaHotelId}/demand/${startDate}/${endDate}`,
      options: {
        headers: {
          Authorization: await MobileAuth.getAuthToken(),
        },
      },
    }).response;
    const text = await rep.body.text();
    const payload = JSON.parse(text);
    return payload;
  }

  static async getOtaHotelCompList(
    otaHotelId: number,
  ): Promise<OtaHotelCompetitorsResponse> {
    const rep = await get({
      apiName: "yield",
      path: `/ota/${otaHotelId}/competitors`,
      options: {
        headers: {
          Authorization: await MobileAuth.getAuthToken(),
        },
      },
    }).response;
    const text = await rep.body.text();
    const payload = JSON.parse(text);
    return payload;
  }

  static async getRatesFromOTATable(
    otaHotelId: number,
    startDate: string,
    endDate: string,
  ): Promise<Record<string, HotelRate>> {
    const rep = await get({
      apiName: "yield",
      path: `/ota/${otaHotelId}/rates/${startDate}/${endDate}`,
      options: {
        headers: {
          Authorization: await MobileAuth.getAuthToken(),
        },
      },
    }).response;
    const text = await rep.body.text();
    const payload = JSON.parse(text);
    return payload;
  }
}
